<template>
  <div id="drawer-box">
    <el-drawer
      ref="drawer"
      :title="title"
      :visible.sync="showdrawer"
      :before-close="closedrawer"
      direction="rtl"
      :modal="false"
      class="drawer-box"
    >
      <!-- 调查表1 -->
      <div v-if="drawerType == 'questionary01'" style="padding: 0px 15px">
        <el-form label-position="top">
          <el-form-item label="请选择生成调查信息类型">
            <el-radio-group v-model="surveyInfo.type">
              <el-radio :label="1">抗癌计划</el-radio>
              <el-radio :label="2">意外计划</el-radio>
              <el-radio :label="3">少儿呼吸道</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="填写事件概况">
            <el-input
              v-model="surveyInfo.eventOverview"
              type="textarea"
              :rows="5"
              placeholder="填写事件概况"
            />
          </el-form-item>
          <el-form-item label="填写调查结论">
            <el-input
              v-model="surveyInfo.eventConclusion"
              type="textarea"
              :rows="5"
              placeholder="填写调查结论"
            />
          </el-form-item>
          <el-form-item label="填写调查过程">
            <el-input
              v-model="surveyInfo.eventProcess"
              type="textarea"
              :rows="5"
              placeholder="填写调查过程"
            />
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="closedrawer">取 消</el-button>
          <el-button
            type="primary"
            :loading="loading"
            @click.stop="createSurveyTable"
          >
            确认生成
          </el-button>
        </div>
      </div>

      <!-- 调查表2 -->
      <div v-if="drawerType == 'questionary02'" style="padding: 0px 15px">
        <el-form label-position="top">
          <el-form-item label="请选择生成调查函类型">
            <el-radio-group v-model="investigationInfo.type">
              <el-radio :label="1">首次委托调查</el-radio>
              <el-radio :label="2">补充委托调查</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="investigationInfo.type == 1">
            <el-form-item label="填写医院信息">
              <el-input
                v-model="investigationInfo.firstInvestigate.hospitalInfo"
                type="textarea"
                :rows="2"
                placeholder="填写医院信息"
              />
            </el-form-item>
            <el-form-item label="填写除常规调查外的特殊调查事项">
              <el-input
                v-model="
                  investigationInfo.firstInvestigate.specialInvestigationItem
                "
                type="textarea"
                :rows="2"
                placeholder="填写除常规调查外的特殊调查事项"
              />
            </el-form-item>
            <el-form-item label="填写调查标准及特殊事项">
              <el-input
                v-model="
                  investigationInfo.firstInvestigate.investigationStandard
                "
                type="textarea"
                :rows="2"
                placeholder="填写调查标准及特殊事项"
              />
            </el-form-item>
          </div>
          <div v-if="investigationInfo.type == 2">
            <el-form-item label="填写除常规调查外的特殊调查事项">
              <el-input
                v-model="
                  investigationInfo.supplementInvestigate.investigationStandard
                "
                type="textarea"
                :rows="2"
                placeholder="填写除常规调查外的特殊调查事项"
              />
            </el-form-item>
            <el-form-item label="填写调查标准及特殊事项">
              <el-input
                v-model="
                  investigationInfo.supplementInvestigate
                    .specialInvestigationItem
                "
                type="textarea"
                :rows="2"
                placeholder="填写调查标准及特殊事项"
              />
            </el-form-item>
          </div>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="closedrawer">取 消</el-button>
          <el-button
            type="primary"
            :loading="loading"
            @click.stop="saveInvestigation"
          >
            保存
          </el-button>
          <el-button
            type="primary"
            :loading="loading"
            @click.stop="createEntrustLetter"
          >
            确认生成
          </el-button>
        </div>
      </div>

      <!-- 事件内容评估（抗癌） -->
      <div v-if="drawerType == 'reportAssess'" style="padding: 0px 15px">
        <el-form label-position="top">
          <el-form-item
            v-for="(item, i) in reportAssess"
            :key="i"
            :label="item.question"
          >
            <el-radio-group
              v-model="item.result"
              @change="changeradio('reportAssess', i)"
            >
              <el-radio
                v-for="(option, index) in item.option"
                :key="index"
                :label="index + 1"
              >
                {{ option.tip }}
              </el-radio>
            </el-radio-group>
            <el-input
              v-if="item.result == 1"
              v-model="item.option[0].remark"
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
            />
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="closedrawer">取 消</el-button>
          <el-button
            type="primary"
            :loading="loading"
            @click="postData('reportAssess')"
          >
            {{ loading ? "提交中 ..." : "确 定" }}
          </el-button>
        </div>
      </div>
      <!-- 事件内容评估（意外） -->
      <div
        v-if="drawerType == 'reportAssess_Accident'"
        style="padding: 0px 15px"
      >
        <el-form label-position="top">
          <el-form-item
            v-for="(item, i) in reportAssess_accident"
            :key="i"
            :label="item.question"
          >
            <el-radio-group
              v-model="item.result"
              @change="changeradio('reportAssess_accident', i)"
            >
              <el-radio
                v-for="(option, index) in item.option"
                :key="index"
                :label="index + 1"
              >
                {{ option.tip }}
              </el-radio>
            </el-radio-group>
            <el-input
              v-if="item.result == 1"
              v-model="item.option[0].remark"
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
            />
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="closedrawer">取 消</el-button>
          <el-button
            type="primary"
            :loading="loading"
            @click="postData('reportAssess_accident')"
          >
            {{ loading ? "提交中 ..." : "确 定" }}
          </el-button>
        </div>
      </div>

      <!-- 审核补充材料一（抗癌） -->
      <div
        v-if="drawerType == 'reportSupplementAssess'"
        style="padding: 0px 15px"
      >
        <el-form label-position="top">
          <el-form-item
            v-for="(item, i) in reportSupplementAssess"
            :key="i"
            :label="item.question"
          >
            <el-radio-group
              v-model="item.result"
              @change="changeradio('reportSupplementAssess', i)"
            >
              <el-radio
                v-for="(option, index) in item.option"
                :key="index"
                :label="index + 1"
              >
                {{ option.tip }}
              </el-radio>
            </el-radio-group>
            <el-input
              v-if="item.result == 1"
              v-model="item.option[0].remark"
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
            />
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="closedrawer">取 消</el-button>
          <el-button
            type="primary"
            :loading="loading"
            @click="postData('reportSupplementAssess')"
          >
            {{ loading ? "提交中 ..." : "确 定" }}
          </el-button>
        </div>
      </div>

      <!-- 审核补充材料一（意外） -->
      <div
        v-if="drawerType == 'reportSupplementAssess_Accident'"
        style="padding: 0px 15px"
      >
        <el-form label-position="top">
          <el-form-item
            v-for="(item, i) in reportSupplementAssess_Accident"
            :key="i"
            :label="item.question"
          >
            <el-radio-group
              v-model="item.result"
              @change="changeradio('reportSupplementAssess_Accident', i)"
            >
              <el-radio
                v-for="(option, index) in item.option"
                :key="index"
                :label="index + 1"
              >
                {{ option.tip }}
              </el-radio>
            </el-radio-group>
            <el-input
              v-if="item.result == 1"
              v-model="item.option[0].remark"
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
            />
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="closedrawer">取 消</el-button>
          <el-button
            type="primary"
            :loading="loading"
            @click="postData('reportSupplementAssess_Accident')"
          >
            {{ loading ? "提交中 ..." : "确 定" }}
          </el-button>
        </div>
      </div>
      <!-- 审核补充材料二-->
      <div
        v-if="drawerType == 'reportSupplementAssessNext'"
        style="padding: 0px 15px"
      >
        <el-form label-position="top">
          <el-form-item
            v-for="(item, i) in reportSupplementAssessNext"
            :key="i"
            :label="item.question"
          >
            <el-radio-group
              v-model="item.result"
              @change="changeradio('reportSupplementAssessNext', i)"
            >
              <el-radio
                v-for="(option, index) in item.option"
                :key="index"
                :label="index + 1"
              >
                {{ option.tip }}
              </el-radio>
            </el-radio-group>
            <el-input
              v-if="item.result == 1"
              v-model="item.option[0].remark"
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
            />
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="closedrawer">取 消</el-button>
          <el-button
            type="primary"
            :loading="loading"
            @click="postData('reportSupplementAssessNext')"
          >
            {{ loading ? "提交中 ..." : "确 定" }}
          </el-button>
        </div>
      </div>
      <!--公估填写委派信息-->
      <div v-if="drawerType == 'delegatedInfo'" style="padding: 0px 15px">
        <el-form label-position="top">
          <el-form-item label="1、委派公估的公司/个人">
            <el-select
              v-model="delegatedInfo.delegatedId"
              class="el-select-block"
              placeholder="请选择"
            >
              <el-option
                v-for="item in delegatedUserRole"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="2、委派公估的案件号/合同编号">
            <el-input v-model="delegatedInfo.delegatedCode" />
          </el-form-item>
          <el-form-item label="3、备注信息">
            <el-select
              v-model="delegatedInfo.remark2"
              class="el-select-block"
              popper-class="el-select-popper"
              :popper-append-to-body="false"
              placeholder="请选择"
              @change="changeDelegatedInfoRemark"
            >
              <el-option
                v-for="item in remarks"
                :key="item.value"
                :label="item.label"
                :value="item.label"
              />
            </el-select>
            <el-input
              v-model="delegatedInfo.remark"
              type="textarea"
              :rows="3"
              style="margin-top: 6px;"
            />
          </el-form-item>
        </el-form>

        <!-- 调查函内容 -->
        <el-card class="box-card letter-block">
          <div slot="header" class="clearfix">
            <span>调查函</span>
          </div>
          <div class="text item">
            <p class="title bold">医院信息</p>
            <p class="txt">{{ letterData.hospital || "暂无信息" }}</p>
          </div>
          <div class="text item">
            <p class="title bold">除常规调查外的特殊调查事项</p>
            <p class="txt">
              {{ letterData.troubleshootContent || "暂无信息" }}
            </p>
          </div>
          <div class="text item">
            <p class="title bold">调查标准及特殊事项</p>
            <p class="txt">{{ letterData.surveyStandard || "暂无信息" }}</p>
          </div>
        </el-card>

        <div class="demo-drawer__footer">
          <el-button @click="closedrawer">取 消</el-button>
          <el-button
            type="primary"
            :loading="loading"
            @click="postData('delegatedInfo')"
          >
            {{ loading ? "提交中 ..." : "确 定" }}
          </el-button>
        </div>
      </div>
      <!--复审（交叉审）事件内容评估-->
      <div v-if="drawerType == 'contentAssessment'" style="padding: 0px 15px">
        <el-form label-position="top">
          <el-form-item
            v-for="(item, i) in contentAssessment"
            :key="i"
            :label="item.question"
          >
            <el-radio-group
              v-model="item.result"
              @change="changeradio('contentAssessment', i)"
            >
              <el-radio
                v-for="(option, index) in item.option"
                :key="index"
                :label="index + 1"
              >
                {{ option.tip }}
              </el-radio>
            </el-radio-group>
            <el-input
              v-if="item.result == 1"
              v-model="item.option[0].remark"
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
            />
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="closedrawer">取 消</el-button>
          <el-button
            type="primary"
            :loading="loading"
            @click="postData('contentAssessment')"
          >
            {{ loading ? "提交中 ..." : "确 定" }}
          </el-button>
        </div>
      </div>
      <!--复审（交叉审）公估调查内容-->
      <div v-if="drawerType == 'investigation'" style="padding: 0px 15px">
        <el-form label-position="top">
          <el-form-item
            v-for="(item, i) in investigation"
            :key="i"
            :label="item.question"
          >
            <el-radio-group
              v-model="item.result"
              @change="changeradio('investigation', i)"
            >
              <el-radio
                v-for="(option, index) in item.option"
                :key="index"
                :label="index + 1"
              >
                {{ option.tip }}
              </el-radio>
            </el-radio-group>
            <div v-if="i == 0">
              <el-input
                v-if="item.result == 2"
                v-model="item.option[1].remark"
                type="textarea"
                :rows="2"
                placeholder="请输入内容"
              >
                {{ item.result }}
              </el-input>
            </div>
            <div v-else>
              <el-input
                v-if="item.result == 1"
                v-model="item.option[0].remark"
                type="textarea"
                :rows="2"
                placeholder="请输入内容"
              />
            </div>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="closedrawer">取 消</el-button>
          <el-button
            type="primary"
            :loading="loading"
            @click="postData('investigation')"
          >
            {{ loading ? "提交中 ..." : "确 定" }}
          </el-button>
        </div>
      </div>

      <!--需要填写备注，并走数据库的配置流程-->
      <div
        v-if="drawerType == 'toRollFlow' || drawerType == 'toNextFlow'"
        style="padding: 0px 15px"
      >
        <el-form label-position="top">
          <el-form-item>
            <el-input
              v-if="drawerType == 'toRollFlow'"
              v-model="toRollFlowRemark"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 10 }"
              placeholder="备注"
            />
            <el-input
              v-else-if="drawerType == 'toNextFlow'"
              v-model="toNextFlowRemark"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 10 }"
              placeholder="备注"
            />
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="closedrawer">取 消</el-button>
          <el-button
            type="primary"
            :loading="loading"
            @click="moveCaseFlow(drawerType)"
          >
            {{ loading ? "提交中 ..." : "确 定" }}
          </el-button>
        </div>
      </div>
      <!--案件中转站操退回，归档，回退到数据库指定的流程-->
      <div
        v-if="drawerType == 'removeStation' || drawerType == 'toFile'"
        style="padding: 0px 15px"
      >
        <el-form label-position="top">
          <el-form-item>
            <el-input
              v-if="drawerType == 'removeStation'"
              v-model="removeStationRemark"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 10 }"
              placeholder="备注"
            />
            <el-input
              v-else-if="drawerType == 'toFile'"
              v-model="toFileRemark"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 10 }"
              placeholder="备注"
            />
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="closedrawer">取 消</el-button>
          <el-button
            type="primary"
            :loading="loading"
            @click="moveCase(drawerType)"
          >
            {{ loading ? "提交中 ..." : "确 定" }}
          </el-button>
        </div>
      </div>

      <!--案件中转站操作跳转到指定流程-->
      <div
        v-if="drawerType == 'jumpFlow' || drawerType == 'repealCase'"
        style="padding: 0px 15px"
      >
        <el-form label-position="left">
          <el-form-item v-if="drawerType == 'jumpFlow'" label="案件流程:">
            <el-cascader
              ref="process"
              v-model="nextFlowEnum"
              :show-all-levels="false"
              :options="processOptions"
              :props="optionProps"
              class="user-input"
              placeholder="一级菜单"
              clearable
              style="width: 300px"
              @change="processChange"
            />
          </el-form-item>
          <el-form-item v-if="drawerType == 'jumpFlow'">
            <el-input
              v-model="jumpFlowRemark"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 10 }"
              placeholder="备注"
            />
          </el-form-item>

          <el-form-item v-if="drawerType == 'repealCase'">
            <el-input
              v-model="repealCaseRemark"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 10 }"
              placeholder="备注"
            />
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="closedrawer">取 消</el-button>
          <el-button
            type="primary"
            :loading="loading"
            @click="jumpcaseflow(drawerType)"
          >
            {{ loading ? "提交中 ..." : "确 定" }}
          </el-button>
        </div>
      </div>

      <!-- 历史记录查看部分 -->
      <div v-else-if="drawerType == '1'" style="padding: 0px 15px">
        <p style="line-height: 25px">{{ remark }}</p>
      </div>
      <div
        v-else-if="
          drawerType == '2' && Array.isArray(JSON.parse(remark)) == true
        "
        style="padding: 0px 15px"
      >
        <el-form ref="reportAssessForm" label-position="top">
          <el-form-item
            v-for="(item, i) in JSON.parse(remark)"
            :key="i"
            :label="item.question"
          >
            <el-radio-group v-model="item.result">
              <el-radio
                v-for="(option, index) in item.option"
                :key="index"
                :label="option.tip"
              >
                {{ option.tip }}
              </el-radio>
            </el-radio-group>
            <el-input
              v-if="item.optionremark && item.optionremark != ''"
              v-model="item.optionremark"
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 10 }"
              disabled
            />
          </el-form-item>
        </el-form>
      </div>
      <div
        v-else-if="
          drawerType == '2' && Array.isArray(JSON.parse(remark)) == false
        "
        style="padding: 0px 15px"
      >
        <el-form ref="reportAssessForm" label-position="top">
          <el-form-item>
            <el-form-item label="1、委派公估的公司/个人">
              <el-input v-model="JSON.parse(remark).delegatedName" disabled />
            </el-form-item>
            <el-form-item label="2、委派公估的案件号/合同编号">
              <el-input v-model="JSON.parse(remark).delegatedCode" disabled />
            </el-form-item>
            <el-form-item label="3、备注信息">
              <el-input
                v-model="JSON.parse(remark).remark"
                type="textarea"
                :rows="3"
                disabled
              />
            </el-form-item>
          </el-form-item>
        </el-form>
      </div>
      <div v-else-if="drawerType == '3'" style="padding: 0px 15px">
        <div
          v-for="(questionItem, questionIndex) in remarkArray"
          :key="questionIndex"
          style="margin-bottom: 4px; padding: 4px"
          :style="questionIndex % 2 == 1 ? 'background: #dedede;' : ''"
        >
          <b>{{ questionIndex + 1 }}、{{ questionItem.questionName }}</b>
          <p
            v-for="(answerItem, answerIndex) in questionItem.options"
            :key="answerIndex"
            style="padding-left: 10px"
          >
            {{ questionIndex + 1 }}.{{ answerIndex + 1 }}:{{
              answerItem.optionalName
            }}
            <br />
            发生时间：{{ answerItem.happenTime }}
            <br />
            备注：{{ answerItem.remark }}
          </p>
        </div>
      </div>
      <!-- 查看邮件内容 -->
      <div
        v-else-if="drawerType == 'email' || drawerType == '4'"
        style="padding: 10px 25px"
      >
        <div v-html="remark" />
      </div>
      <!-- 疑点排查 -->
      <div v-else-if="drawerType == '5'" style="padding: 0px 15px">
        <div style="margin-bottom: 4px; padding: 4px">
          <b>{{ remark.questionName }}</b>
          <p
            v-for="(answerItem, answerIndex) in remark.optionsInfos"
            :key="answerIndex"
            style="padding-left: 10px"
          >
            {{ answerIndex + 1 }}：{{ answerItem.suspectInfo }}
            <br />
            备注：{{ answerItem.remark }}
            <br />
            疑点标注时间：{{ answerItem.createTime }}
            <br />
            备注人：{{ answerItem.creator }}
          </p>
        </div>
      </div>
    </el-drawer>

    <el-dialog
      v-if="cases != undefined"
      title="发送邮件"
      :visible.sync="emailDialog"
      width="90%"
      custom-class="c-p"
    >
      <sendEmail
        :case-code="cases.caseCode"
        :version="cases.infoVersion"
        :show-email-tab="showEmailTab"
        :is-refresh-btn="false"
        @updateFlow="updateCaseFlow"
      />
    </el-dialog>
  </div>
</template>

<script>
import SendEmail from "@/pages/email/SendEmail.vue"; // 发送邮件

export default {
  components: {
    SendEmail,
  },
  props: {
    cases: {
      type: Object,
      default: () => {},
    },
    showdrawer: Boolean,
    drawerType: {
      type: String,
      default: () => "",
    },
    buttonName: {
      type: String,
      default: () => "",
    },
    caseStatus: {
      type: String,
      default: () => "",
    },
    remark: {
      type: [String, Object],
      default: () => "",
    },
    remarkArray: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      title: "查看历史操作详情",
      emailDialog: false,
      showEmailTab: [],
      formType: "",
      surveyInfo: {
        caseCode: "",
        type: 1, // 调查类型 1 癌症  2 意外  3 少儿特定疾病
        eventOverview: "",
        eventConclusion: "",
        eventProcess: "",
      },

      investigationInfo: {
        caseCode: null,
        version: null,
        type: 1,
        firstInvestigate: {
          hospitalInfo: null,
          specialInvestigationItem: null,
          investigationStandard: null,
        },
        supplementInvestigate: {
          specialInvestigationItem: null,
          investigationStandard: null,
        },
      },

      reportAssess: [
        // 抗癌初审事件评估内容
        {
          question: "1、入院记录的主诉和现病史是否有不予互助情况？",
          option: [
            { tip: "是", checked: false, type: 1, remark: "" },
            { tip: "否", checked: false, type: 0, remark: "" },
            { tip: "缺乏资料判断", checked: false, type: 0, remark: "" },
          ],
          result: null,
        },
        {
          question: "2、入院记录的主要既往病史是否有不予互助的情况？",
          option: [
            { tip: "是", checked: false, type: 1, remark: "" },
            { tip: "否", checked: false, type: 0, remark: "" },
            { tip: "缺乏资料判断", checked: false, type: 0, remark: "" },
          ],
          result: null,
        },
        {
          question: "3、过往健康状况是否有不予互助的情况？",
          option: [
            { tip: "是", checked: false, type: 1, remark: "" },
            { tip: "否", checked: false, type: 0, remark: "" },
            { tip: "缺乏资料判断", checked: false, type: 0, remark: "" },
          ],
          result: null,
        },
      ],
      reportAssess_accident: [
        // 意外初审事件评估内容
        {
          question: "1、过往健康状况是否有不予互助的情况？",
          option: [
            { tip: "是", checked: false, type: 1, remark: "" },
            { tip: "否", checked: false, type: 0, remark: "" },
            { tip: "缺乏资料判断", checked: false, type: 0, remark: "" },
          ],
          result: null,
        },
        {
          question: "1、是否符合不予互助的情形？",
          option: [
            {
              tip: "是",
              checked: false,
              type: 1,
              remark: "",
            },
            {
              tip: "否",
              checked: false,
              type: 0,
              remark: "",
            },
            {
              tip: "缺乏资料判断",
              checked: false,
              type: 0,
              remark: "",
            },
          ],
          result: null,
        },
      ],
      reportSupplementAssess: [
        // 抗癌审核补充材料1
        {
          question: "1、入院记录的主诉和现病史是否有不予互助情况？",
          option: [
            {
              tip: "是",
              checked: false,
              type: 1,
              remark: "",
            },
            {
              tip: "否",
              checked: false,
              type: 0,
              remark: "",
            },
          ],
          result: null,
        },
        {
          question: "2、入院记录的主要既往病史是否有不予互助的情况？",
          option: [
            {
              tip: "是",
              checked: false,
              type: 1,
              remark: "",
            },
            {
              tip: "否",
              checked: false,
              type: 0,
              remark: "",
            },
          ],
          result: null,
        },
        {
          question: "3、过往健康状况是否有不予互助的情况？",
          option: [
            {
              tip: "是",
              checked: false,
              type: 1,
              remark: "",
            },
            {
              tip: "否",
              checked: false,
              type: 0,
              remark: "",
            },
          ],
          result: null,
        },
        {
          question: "4、体检报告是否有不予互助的情况？",
          option: [
            {
              tip: "是",
              checked: false,
              type: 1,
              remark: "",
            },
            {
              tip: "否",
              checked: false,
              type: 0,
              remark: "",
            },
          ],
          result: null,
        },
      ],
      reportSupplementAssess_Accident: [
        // 意外审核补充材料1
        {
          question: "1、过往健康状况是否有不予互助的情况？",
          option: [
            { tip: "是", checked: false, type: 1, remark: "" },
            { tip: "否", checked: false, type: 0, remark: "" },
            { tip: "缺乏资料判断", checked: false, type: 0, remark: "" },
          ],
          result: null,
        },
        {
          question: "2、是否符合不予互助的情形？",
          option: [
            { tip: "是", checked: false, type: 1, remark: "" },
            { tip: "否", checked: false, type: 0, remark: "" },
            { tip: "缺乏资料判断", checked: false, type: 0, remark: "" },
          ],
          result: null,
        },
      ],
      reportSupplementAssessNext: [
        // 审核补充资料2
        {
          question: "1、是否需要补充材料？",
          option: [
            {
              tip: "是",
              checked: false,
              type: 1,
              remark: "",
            },
            {
              tip: "否",
              checked: false,
              type: 0,
              remark: "",
            },
          ],
          result: null,
        },
        {
          question: "2、是否需要增加调查项目（除对应风险度需调查的项目外）？",
          option: [
            {
              tip: "是",
              checked: false,
              type: 1,
              remark: "",
            },
            {
              tip: "否",
              checked: false,
              type: 0,
              remark: "",
            },
          ],
          result: null,
        },
      ],
      delegatedInfo: {
        // 公估填写委派信息
        delegatedName: "",
        delegatedCode: "",
        delegatedId: "", // 公估公司/个人用户ID
        remark: "", // 备注信息
        remark2: "", // 备注信息（下拉框）
      },
      delegatedUserRole: [], // 委派公估的公司/个人的选项列表
      remarks: [
        {
          value: "选项1",
          label:
            "本案全案委托，至少需完成以下调查点（面访，医保商保，XXXX（各医院住院+门诊+体检科）以及排查社区医院+邻近专科或大型医院3间+体检机构+走访单位核实体检情况（如有必要））",
        },
        {
          value: "选项2",
          label: "老师好，本案为整案委托，最少完成面访+核实本次确诊事实（）",
        },
      ], // 备注信息列表
      letterData: {}, // 最近首次调查函内容
      contentAssessment: [
        // 复审（交叉审）事件内容评估
        {
          question: "1、入院记录的主诉和现病史是否有不予互助情况？",
          option: [
            {
              tip: "是",
              checked: false,
              type: 1,
              remark: "",
            },
            {
              tip: "否",
              checked: false,
              type: 0,
              remark: "",
            },
            {
              tip: "缺乏资料判断",
              checked: false,
              type: 0,
              remark: "",
            },
          ],
          result: null,
        },

        {
          question: "2、入院记录的主要既往病史是否有不予互助的情况？",
          option: [
            {
              tip: "是",
              checked: false,
              type: 1,
              remark: "",
            },
            {
              tip: "否",
              checked: false,
              type: 0,
              remark: "",
            },
            {
              tip: "缺乏资料判断",
              checked: false,
              type: 0,
              remark: "",
            },
          ],
          result: null,
        },
        {
          question: "3、过往健康状况是否有不予互助的情况？",
          option: [
            {
              tip: "是",
              checked: false,
              type: 1,
              remark: "",
            },
            {
              tip: "否",
              checked: false,
              type: 0,
              remark: "",
            },
            {
              tip: "缺乏资料判断",
              checked: false,
              type: 0,
              remark: "",
            },
          ],
          result: null,
        },
        {
          question: "4、体检报告是否有不予互助的情况？",
          option: [
            {
              tip: "是",
              checked: false,
              type: 1,
              remark: "",
            },
            {
              tip: "否",
              checked: false,
              type: 0,
              remark: "",
            },
            {
              tip: "缺乏资料判断",
              checked: false,
              type: 0,
              remark: "",
            },
          ],
          result: null,
        },
      ],
      investigation: [
        // 复审（交叉审）公估调查内容
        {
          question: "1、调查内容是否符合要求？",
          option: [
            {
              tip: "是",
              checked: false,
              type: 1,
              remark: "",
            },
            {
              tip: "否",
              checked: false,
              type: 0,
              remark: "",
            },
          ],
          result: null,
        },
        {
          question: "2、是否有需要增加调查项目？",
          option: [
            {
              tip: "是",
              checked: false,
              type: 1,
              remark: "",
            },
            {
              tip: "否",
              checked: false,
              type: 0,
              remark: "",
            },
          ],
          result: null,
        },
        {
          question: "3、是否需要补充材料？",
          option: [
            {
              tip: "是",
              checked: false,
              type: 1,
              remark: "",
            },
            {
              tip: "否",
              checked: false,
              type: 0,
              remark: "",
            },
          ],
          result: null,
        },
      ],

      removeStationRemark: "", // 案件中转站退回备注
      jumpFlowRemark: "", // 案件中转站跳到指定流程备注
      repealCaseRemark: "", // 案件中转站撤案备注
      toFileRemark: "", // 案件中转站归档备注
      toNextFlowRemark: "", // 下一步备注
      toRollFlowRemark: "", // 退回备注

      nextFlowEnum: "", // 案件中转站跳到指定流程编号
      processOptions: [],
      optionProps: {
        // expandTrigger: 'hover',
        value: "flowCode",
        label: "name",
        children: "children",
      },
    };
  },

  watch: {
    showdrawer() {
      this.init();
    },

    drawerType() {
      console.log("drawerType", this.drawerType);
      const { drawerType, processOptions } = this;
      this.initTitle();
      // 案件中转站，判断当前是否需要获取案件流程数据
      if (drawerType === "jumpFlow" && processOptions.length === 0) {
        this.getprocess();
      }
    },
  },

  created() {
    const { drawerType, processOptions } = this;
    console.log("created:drawerType", drawerType);

    this.initTitle();
    // 案件中转站，判断当前是否需要获取案件流程数据
    if (drawerType === "jumpFlow" && processOptions.length === 0) {
      this.getprocess();
    }
  },

  methods: {
    init() {
      if (this.showdrawer) {
        const { drawerType } = this;
        if (drawerType === "questionary01") {
          this.surveyInfo.type = 1;
          this.surveyInfo.eventConclusion = "";
          this.surveyInfo.eventOverview = "";
          this.surveyInfo.eventProcess = "";
        } else if (drawerType === "questionary02") {
          this.getInvestigation();
          this.investigationInfo.type = 1;
        } else if (drawerType === "delegatedInfo") {
          this.fetchSysUserRole();
          this.fetchCaseInvestigationHistory();
        }
      }
    },

    initTitle() {
      if (this.drawerType === "questionary01") {
        this.title = "生成调查表";
      } else if (this.drawerType === "questionary02") {
        this.title = "生成调查函";
      } else if (
        this.drawerType === "reportAssess" ||
        this.drawerType === "reportAssess_Accident" ||
        this.drawerType === "contentAssessment"
      ) {
        this.title = "事件内容评估";
      } else if (
        this.drawerType === "reportSupplementAssess" ||
        this.drawerType === "reportSupplementAssess_Accident" ||
        this.drawerType === "reportSupplementAssessNext"
      ) {
        this.title = "审核补充材料";
      } else if (this.drawerType === "delegatedInfo") {
        this.title = "公估填写委派信息";
      } else if (this.drawerType === "investigation") {
        this.title = "请填写调查内容";
      } else if (this.drawerType === "toRollFlow") {
        this.title = "退回";
      } else if (this.drawerType === "toNextFlow") {
        this.title = "退回";
      } else if (
        this.drawerType === "removeStation" ||
        this.drawerType === "jumpFlow"
      ) {
        this.title = "案件中转站";
      } else if (this.drawerType === "repealCase") {
        this.title = "撤案";
      } else if (this.drawerType === "toFile") {
        this.title = "不予互助";
      } else if (this.drawerType === "email") {
        this.title = "查看邮件内容";
      } else {
        this.title = "查看历史操作详情";
      }
    },

    closedrawer() {
      this.$emit("closedrawer", false);
    },

    /**
     * 获取案件流程的数据
     */
    getprocess() {
      const vm = this;
      vm.axios
        .get("/case/flow/select")
        .then((res) => {
          if (res.data.status === "000000") {
            const data = res.data.flowList;
            const processData = vm.filterNull(
              vm.toTreeData(data, "parentCode", "flowCode")
            );
            processData.filter((item) => {
              if (item.aliasName === "归档" || item.aliasName === "待归档") {
                // Do something about it
              } else {
                this.processOptions.push(item);
              }
            });
          } else {
            console.warn("接口(/case/flow/select)请求失败", res.data.message);
            // vm.$alert(res.data.message, '提示')
          }
        })
        .catch((error) => console.log(error));
    },

    createSurveyTable() {
      this.loading = true;
      this.surveyInfo.caseCode = this.cases.caseCode;
      this.axios({
        url: "/casesCommon/createSurveyTable",
        method: "put",
        data: this.surveyInfo,
        headers: {
          "Content-type": "application/json",
        },
      })
        .then((res) => {
          const result = res.data;
          if (result.status === "000000") {
            this.$alert("操作成功", "提示", {
              callback: () => {
                this.$emit("closedrawer", false);
                this.$emit("getImageByCaseCode");
              },
            });
          } else {
            this.$alert(result.message, "提示", {
              callback: () => {
                this.$emit("closedrawer", false);
              },
            });
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getInvestigation() {
      const vm = this;
      const caseCode = vm.cases.caseCode;
      vm.axios
        .get("/casesCommon/investigation/query?caseCode=" + caseCode)
        .then((res) => {
          const resData = res.data;
          if (resData.status === "000000") {
            if (resData.data.firstInvestigate != null) {
              vm.investigationInfo.firstInvestigate =
                resData.data.firstInvestigate;
            }
            if (resData.data.supplementInvestigate != null) {
              vm.investigationInfo.supplementInvestigate =
                resData.data.supplementInvestigate;
            }
            vm.investigationInfo.caseCode = vm.cases.caseCode;
            vm.investigationInfo.version =
              resData.data.version == null ? 0 : resData.data.version;
          } else {
            vm.$alert(resData.message, "提示");
          }
        })
        .catch((error) => console.log(error));
    },

    saveInvestigation() {
      this.axios
        .post("/casesCommon/investigation/save", this.investigationInfo)
        .then((res) => {
          this.loading = false;
          if (res.data.status === "000000") {
            this.$alert("保存成功", "提示", {
              callback: () => {
                this.getInvestigation();
              },
            });
          } else {
            this.$alert(res.data.message, "提示", {
              callback: () => {
                this.$emit("closedrawer", false);
              },
            });
          }
        })
        .catch((error) => console.log(error));
    },

    createEntrustLetter() {
      const vm = this;
      vm.loading = true;
      const inquireInfo = {
        caseCode: vm.cases.caseCode,
        type: vm.investigationInfo.type, // 1 首次委托调查 2补充调查
        hospital:
          Number(vm.investigationInfo.type) === 1
            ? vm.investigationInfo.firstInvestigate.hospitalInfo
            : null,
        troubleshootContent:
          Number(vm.investigationInfo.type) === 1
            ? vm.investigationInfo.firstInvestigate.specialInvestigationItem
            : vm.investigationInfo.supplementInvestigate
                .specialInvestigationItem,
        surveyStandard:
          Number(vm.investigationInfo.type) === 1
            ? vm.investigationInfo.firstInvestigate.investigationStandard
            : vm.investigationInfo.supplementInvestigate.investigationStandard,
      };

      vm.axios({
        url: "/casesCommon/createEntrustLetter",
        method: "put",
        data: inquireInfo,
        headers: {
          "Content-type": "application/json",
        },
      })
        .then((res) => {
          const result = res.data;
          if (result.status === "000000") {
            vm.$alert("操作成功", "提示", {
              callback: () => {
                vm.$emit("closedrawer", false);
                vm.$emit("getImageByCaseCode");
              },
            });
          } else {
            vm.$alert(result.message, "提示", {
              callback: () => {
                vm.$emit("closedrawer", false);
              },
            });
          }
          vm.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeradio(type, i) {
      // const currentRadioGroup = this[type][i]
      const currentOptions = this[type][i].option;
      const currentResult = this[type][i].result;
      currentOptions.filter((item, index) => {
        if (index + 1 !== Number(currentResult)) {
          item.checked = false;
        } else {
          item.checked = true;
        }
      });
    },

    postData(type) {
      this.formType = type;
      if (type === "reportAssess" || type === "reportAssess_accident") {
        this.loading = true;
        // 保存事件评估内容
        this.postReportAssess(type);
      } else if (
        type === "reportSupplementAssess" ||
        type === "reportSupplementAssess_Accident"
      ) {
        this.loading = true;
        // 保存审核补充资料一
        this.postReportSupplementAssess(type);
      } else if (type === "reportSupplementAssessNext") {
        const answerJson = [];
        this[type].filter((item) => {
          answerJson.push({ result: item.result, remark: "" });
        });
        this.getMailList(answerJson);
        // 保存审核补充资料二
        // this.postReportSupplementAssessNext(type)
      } else if (type === "delegatedInfo") {
        // 提交委派信息
        // this.loading = true;
        this.getMailList();
      } else if (type === "contentAssessment") {
        const answerJson = [];

        this[type].filter((item) => {
          answerJson.push({ result: item.result, remark: "" });
        });

        this.getMailList(answerJson);
        // 保存复审(交叉审)事件内容评估
        // this.postContentAssessment(type)
      } else if (type === "investigation") {
        this.loading = true;
        // 保存复审（交叉审）公估调查内容
        this.postInvestigation(type);
      }
    },
    getMailList(answerJson) {
      // 如果当前
      var req = {
        answerJson: JSON.stringify(answerJson),
        caseCode: this.cases.caseCode,
      };
      this.axios
        .post("/flow-mail/mails", req)
        .then((res) => {
          if (res.data.status === "000000") {
            var respEmailList = res.data.data;
            if (respEmailList !== undefined && respEmailList.length > 0) {
              var emailTab = [];
              respEmailList.forEach((emailItem) => {
                var templateType = emailItem.templateType.substring(4, 6);
                emailTab.push("tab" + templateType);
              });

              this.emailDialog = true;
              this.showEmailTab = emailTab;
            } else {
              this.updateCaseFlow();
            }
          } else {
            this.$alert(res.data.message, "提示");
          }
        })
        .catch((error) => console.log(error));
    },
    updateCaseFlow() {
      this.emailDialog = false;
      if (this.formType === "reportSupplementAssessNext") {
        // 保存审核补充资料二
        this.postReportSupplementAssessNext(this.formType);
      } else if (this.formType === "contentAssessment") {
        // 保存复审(交叉审)事件内容评估
        // this.postContentAssessment(type)
        this.postInvestigation(this.formType);
      } else if (this.formType === "delegatedInfo") {
        // 保存复审(交叉审)事件内容评估
        this.postDelegatedInfo();
      }
    },
    postReportAssess(type) {
      // 保存事件评估内容
      const dataJson = [];
      this[type].filter((item) => {
        const obj = {};
        if (item.result === 1) {
          obj.result = item.result;
          obj.remark = item.option[0].remark;
        } else {
          obj.result = item.result;
        }
        dataJson.push(obj);
      });

      const requestJson = {
        version: this.cases.infoVersion,
        caseCode: this.cases.caseCode,
        reportInfoDetail: {
          healthyDetail: this[type],
        },
        reportData: {
          healthyData: dataJson,
        },
      };

      this.axios
        .post("/first-trail/event/assessment/page1", requestJson)
        .then((res) => {
          this.loading = false;
          if (res.data.status === "000000") {
            this.$alert("提交成功", "提示", {
              callback: (action) => {
                this.$emit("closedrawer", false);
                this.$emit("getcaseInfo");
              },
            });
          } else {
            this.$alert(res.data.message, "提示", {
              callback: (action) => {
                this.$emit("closedrawer", false);
              },
            });
          }
        })
        .catch((error) => console.log(error));
    },

    postReportSupplementAssess(type) {
      // 保存审核补充资料一
      const dataJson = [];
      this[type].filter((item) => {
        const obj = {};
        if (Number(item.result) === 1) {
          obj.result = item.result;
          obj.remark = item.option[0].remark;
        } else {
          obj.result = item.result;
        }
        dataJson.push(obj);
      });

      const requestJson = {
        version: this.cases.infoVersion,
        caseCode: this.cases.caseCode,
        reportInfoDetail: {
          healthyDetail: this[type],
        },
        reportData: {
          healthyData: dataJson,
        },
      };

      this.axios
        .post("/first-trail/check-supply-info/page1", requestJson)
        .then((res) => {
          this.loading = false;
          if (res.data.status === "000000") {
            this.$alert("提交成功", "提示", {
              callback: () => {
                this.$emit("closedrawer", false);
                this.$emit("getcaseInfo");
              },
            });
          } else {
            this.$alert(res.data.message, "提示", {
              callback: () => {
                this.$emit("closedrawer", false);
              },
            });
          }
        })
        .catch((error) => console.log(error));
    },

    postReportSupplementAssessNext(type) {
      // 保存审核补充资料二
      const dataJson = [];
      this[type].filter((item) => {
        const obj = {};
        if (Number(item.result) === 1) {
          obj.result = item.result;
          obj.remark = item.option[0].remark;
        } else {
          obj.result = item.result;
        }
        dataJson.push(obj);
      });

      const requestJson = {
        version: this.cases.infoVersion,
        caseCode: this.cases.caseCode,
        reportInfoDetail: {
          healthyDetail: this[type],
        },
        reportData: {
          healthyData: dataJson,
        },
      };

      this.axios
        .post("/first-trail/check-supply-info/page2", requestJson)
        .then((res) => {
          this.loading = false;
          if (res.data.status === "000000") {
            this.$alert("提交成功", "提示", {
              callback: () => {
                this.$emit("closedrawer", false);
                this.$emit("getcaseInfo");
              },
            });
          } else {
            this.$alert(res.data.message, "提示", {
              callback: () => {
                this.$emit("closedrawer", false);
              },
            });
          }
        })
        .catch((error) => console.log(error));
    },

    /**
     * 通过角色ID获取用户名和ID
     */
    async fetchSysUserRole() {
      const _this = this;
      const roleId = "1000042";

      try {
        const { data: result } = await _this.axios.get(
          `/sys/user/role/${roleId}`
        );
        if (result && result.status === "000000") {
          const newData = result.data;
          const keys = Object.keys(newData);
          const delegatedUserRole = [];

          // 遍历keys数组，重新组合公估公司/个人用户的选项数组
          keys &&
            keys.forEach((items) => {
              delegatedUserRole.push({
                value: items,
                label: newData[items],
              });
            });
          _this.delegatedUserRole = delegatedUserRole;
        } else {
          _this.$alert(
            (result && result.message) || "服务器繁忙，请稍后重试",
            "提示"
          );
        }
      } catch (error) {
        console.log("通过角色ID获取用户名和ID-请求失败", error);
      }
    },

    /**
     * 通过案件编号获取最近首次调查函
     */
    async fetchCaseInvestigationHistory() {
      const _this = this;
      const { caseCode } = _this.cases;

      try {
        const { data: result } = await _this.axios.get(
          `/casesCommon/investigation/history/${caseCode}`
        );
        if (result && result.status === "000000") {
          _this.letterData = result.data;
        } else {
          _this.$alert(
            (result && result.message) || "服务器繁忙，请稍后重试",
            "提示"
          );
        }
      } catch (error) {
        console.log("通过案件编号获取最近首次调查函-请求失败", error);
      }
    },

    /**
     * 提交委派信息
     */
    async postDelegatedInfo() {
      const vm = this;
      const { delegatedUserRole } = vm;
      const { infoVersion, caseCode } = vm.cases;
      const { delegatedCode, delegatedId, remark } = vm.delegatedInfo;

      if (!delegatedId) {
        vm.$message.error("请选择委派公估的公司/个人");
      } else {
        let delegatedName = "";

        // 遍历选项列表，查询对应的选项名称
        delegatedUserRole &&
          delegatedUserRole.forEach((item) => {
            if (item.value === delegatedId) delegatedName = item.label;
          });

        // 请求的参数
        const delegatedInfo = {
          version: infoVersion,
          caseCode,
          result: JSON.stringify({
            listDetail: {
              delegatedName, // 委派公估的公司/个人
              delegatedCode, // 委派公估的案件号/合同编号
              // 以下内容2021年7月27日新增
              delegatedId, // 公估公司/个人用户ID
              remark, // 备注信息
            },
          }),
        };

        try {
          const { data: result } = await vm.axios.post(
            "/publicAssessment/saveDelegation",
            delegatedInfo
          );
          vm.loading = false;
          if (result.status === "000000") {
            vm.$alert("提交成功", "提示", {
              callback: () => {
                vm.$emit("closedrawer", false);
                vm.$emit("getcaseInfo");
              },
            });
          } else {
            vm.$alert(result.message, "提示", {
              callback: () => {
                vm.$emit("closedrawer", false);
              },
            });
          }
        } catch (error) {
          console.log("公估-保存委派信息-请求失败", error);
        }
      }
    },

    postContentAssessment(type) {
      // 保存复审(交叉审)事件内容评估
      const dataJson = [];
      this[type].filter((item) => {
        const obj = {};
        if (Number(item.result) === 1) {
          obj.result = item.result;
          obj.remark = item.option[0].remark;
        } else {
          obj.result = item.result;
        }
        dataJson.push(obj);
      });

      const requestJson = {
        version: this.cases.infoVersion,
        caseCode: this.cases.caseCode,
        reportInfoDetail: {
          healthyDetail: this[type],
        },
        reportData: {
          healthyData: dataJson,
        },
      };

      this.axios
        .post("/caseReview/saveEventEvaluation", requestJson)
        .then((res) => {
          this.loading = false;
          if (res.data.status === "000000") {
            this.$alert("提交成功", "提示", {
              callback: () => {
                this.$emit("closedrawer", false);
                this.$emit("getcaseInfo");
              },
            });
          } else {
            this.$alert(res.data.message, "提示", {
              callback: () => {
                this.$emit("closedrawer", false);
              },
            });
          }
        })
        .catch((error) => console.log(error));
    },

    postInvestigation(type) {
      // 保存复审（交叉审）公估调查内容
      const dataJson = [];
      this[type].filter((item) => {
        const obj = {};
        obj.result = item.result;
        obj.remark = item.option[item.result - 1].remark;
        dataJson.push(obj);
      });

      const requestJson = {
        version: this.cases.infoVersion,
        caseCode: this.cases.caseCode,
        reportInfoDetail: {
          healthyDetail: this[type],
        },
        reportData: {
          healthyData: dataJson,
        },
      };

      this.axios
        .post("/caseReview/savePublicAssessmentSurvey", requestJson)
        .then((res) => {
          this.loading = false;
          if (res.data.status === "000000") {
            this.$alert("提交成功", "提示", {
              callback: () => {
                this.$emit("closedrawer", false);
                this.$emit("getcaseInfo");
              },
            });
          } else {
            this.$alert(res.data.message, "提示", {
              callback: () => {
                this.$emit("closedrawer", false);
              },
            });
          }
        })
        .catch((error) => console.log(error));
    },

    moveCase(operation) {
      let msg = "";
      switch (operation) {
        case "removeStation":
          msg = "取消中转";
          break;
        case "toFile":
          msg = "不予互助";
          break;
      }

      this.$confirm("确定要进行" + msg + "操作吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const remark = this[operation + "Remark"];
          const params = {
            caseCode: this.cases.caseCode,
            operation: operation,
            remark: remark,
          };
          this.axios
            .post("/case-station/changeStation/", params)
            .then((res) => {
              if (res.data.status === "000000") {
                this.$emit("closedrawer", false);
                this.$emit("getcaseInfo");
              } else {
                this.$alert(res.data.message, "提示", {
                  callback: () => {
                    this.$emit("closedrawer", false);
                  },
                });
              }
            })
            .catch((error) => console.log(error));
        })
        .catch(() => {});
    },

    processChange(val) {
      if (val.length > 0) {
        const length = val.length;
        this.nextFlowEnum = val[length - 1];
      }
    },

    jumpcaseflow(operation) {
      let msg = "";
      let menuCode = "";
      switch (operation) {
        case "jumpFlow":
          msg = "跳到指定流程";
          menuCode = 32;
          break;
        case "repealCase":
          msg = "撤案";
          menuCode = 1;
          break;
      }

      this.$confirm("确定要进行" + msg + "操作吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const remark = this[operation + "Remark"];
          const jumpData = {
            version: this.cases.infoVersion,
            caseCode: this.cases.caseCode,
            menuCode: menuCode,
            nextFlowEnum: this.nextFlowEnum,
            remark: remark,
          };
          this.axios
            .put("/case-station/jumpFlow", jumpData)
            .then((res) => {
              if (res.data.status === "000000") {
                this.$emit("closedrawer", false);
                this.$emit("getcaseInfo");
              } else {
                this.$alert(res.data.message, "提示", {
                  callback: () => {
                    this.$emit("closedrawer", false);
                  },
                });
              }
            })
            .catch((error) => console.log(error));
        })
        .catch(() => {});
    },

    moveCaseFlow(operation) {
      // let msg = ''
      let menuCode = "";
      switch (operation) {
        case "toRollFlow":
          // msg = '回退'
          menuCode = 128;
          break;
        case "toNextFlow":
          // msg = '下一步'
          menuCode = 1;
          break;
      }

      this.$confirm("确定要进行" + this.buttonName + "操作吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const remark = this[operation + "Remark"];
          const updateObj = {
            version: this.cases.infoVersion,
            caseCode: this.cases.caseCode,
            remark: remark,
            menuCode: menuCode,
            caseStatus: this.caseStatus,
            buttonName: this.buttonName,
          };

          this.axios
            .put("/casesCommon/caseNextStep", updateObj)
            .then((res) => {
              const result = res.data;
              if (result.status === "000000") {
                this.$emit("closedrawer", false);
                this.$emit("getcaseInfo");
              } else {
                this.$alert(result.message, "提示", {
                  callback: () => {
                    this.$emit("closedrawer", false);
                  },
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {});
    },

    /**
     * 监听备注信息-选项内容的变化
     * @param {string} value 选中的值
     */
    changeDelegatedInfoRemark(value) {
      this.delegatedInfo.remark = value;
    },
  },
};
</script>

<style scoped lang="scss">
.el-drawer__header {
  display: flex;
}

/* 公估填写委派信息-调查函 */
.letter-block {
  margin-bottom: 50px;

  .item {
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .title {
    font-size: 13px;
    font-weight: bold;
    margin-bottom: 5px;
  }

  .txt {
    font-size: 12px;
    color: #555;
    line-height: 20px;
    margin-bottom: 0;
  }
}

.el-select-block {
  width: 100%;
}

// 下拉框的选项样式
/deep/ .el-select-popper {
  max-width: 200px !important;
}

.demo-drawer__footer {
  padding-bottom: 20px;
}
</style>
